import React from 'react';
import {Comment} from './types'
interface CommentListProps{
  comments:Comment[]
}
const CommentList:React.FunctionComponent<CommentListProps> = ({comments}:CommentListProps) => <>
      <hr/>
    {
      comments?.length ? <ul>

            {
              comments?.map(
                (comment,i) => <>
                  <li key={i}> {comment.username} - {comment.comment}</li>
                  <hr/>
                  </>
              )
            }
          </ul> : <p>No Comments yet</p>
    }
  </>;
export default CommentList;
